import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHash = () => {
    const { pathname, hash, key } = useLocation();

    useEffect(() => {
        // Si no hay hash, scrollear al inicio
        if (hash === "") {
            window.scrollTo(0, 0);
        } else {
            // Intentar scrollear al elemento con el ID del hash con offset para el header
            setTimeout(() => {
                const id = hash.replace("#", "");
                const element = document.getElementById(id);
                if (element) {
                    const offset = 100; // Altura aproximada del header fijo para dejar espacio
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementRect = element.getBoundingClientRect().top;
                    const elementPosition = elementRect - bodyRect;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }
            }, 100); // Pequeño timeout para asegurar que el DOM esté listo
        }
    }, [pathname, hash, key]);

    return null;
};

export default ScrollToHash;
